var map = {
	"./ad.svg": 71766,
	"./ae.svg": 53609,
	"./af.svg": 14425,
	"./ag.svg": 11345,
	"./ai.svg": 90896,
	"./al.svg": 21881,
	"./am.svg": 72454,
	"./ao.svg": 58758,
	"./ar.svg": 27785,
	"./as.svg": 86937,
	"./at.svg": 40104,
	"./au.svg": 98970,
	"./aw.svg": 64083,
	"./az.svg": 83712,
	"./ba.svg": 4473,
	"./bb.svg": 4209,
	"./bd.svg": 79164,
	"./be.svg": 56119,
	"./bf.svg": 51987,
	"./bg.svg": 46916,
	"./bh.svg": 65640,
	"./bi.svg": 43016,
	"./bj.svg": 29147,
	"./bm.svg": 5915,
	"./bo.svg": 45866,
	"./br.svg": 61410,
	"./bs.svg": 68722,
	"./bt.svg": 78119,
	"./bw.svg": 88711,
	"./by.svg": 7879,
	"./bz.svg": 60803,
	"./ca.svg": 59183,
	"./cd.svg": 41314,
	"./cf.svg": 34355,
	"./cg.svg": 87644,
	"./ch.svg": 91362,
	"./ci.svg": 98986,
	"./ck.svg": 44006,
	"./cl.svg": 42354,
	"./cm.svg": 67288,
	"./cn.svg": 60015,
	"./co.svg": 87374,
	"./cr.svg": 91801,
	"./cu.svg": 69803,
	"./cv.svg": 67185,
	"./cw.svg": 15141,
	"./cy.svg": 26267,
	"./cz.svg": 91832,
	"./de.svg": 19830,
	"./dj.svg": 54875,
	"./dk.svg": 71167,
	"./dm.svg": 9359,
	"./do.svg": 23715,
	"./dz.svg": 44013,
	"./ec.svg": 48103,
	"./ee.svg": 42827,
	"./eg.svg": 84940,
	"./er.svg": 89658,
	"./es.svg": 48393,
	"./et.svg": 96171,
	"./fi.svg": 1293,
	"./fj.svg": 25394,
	"./fk.svg": 23571,
	"./fm.svg": 19785,
	"./fo.svg": 33678,
	"./fr.svg": 43405,
	"./ga.svg": 58498,
	"./gb.svg": 82223,
	"./gd.svg": 45002,
	"./ge.svg": 33426,
	"./gg.svg": 10323,
	"./gh.svg": 60141,
	"./gi.svg": 78316,
	"./gl.svg": 21966,
	"./gm.svg": 81952,
	"./gn.svg": 54721,
	"./gq.svg": 90970,
	"./gr.svg": 84384,
	"./gt.svg": 78884,
	"./gu.svg": 61058,
	"./gw.svg": 25834,
	"./hk.svg": 67039,
	"./hn.svg": 95279,
	"./hr.svg": 57076,
	"./ht.svg": 65907,
	"./hu.svg": 66236,
	"./id.svg": 27729,
	"./ie.svg": 49198,
	"./il.svg": 21132,
	"./im.svg": 1075,
	"./in.svg": 37721,
	"./io.svg": 19412,
	"./iq.svg": 99383,
	"./ir.svg": 18730,
	"./is.svg": 84298,
	"./it.svg": 51262,
	"./je.svg": 71432,
	"./jm.svg": 89978,
	"./jo.svg": 46914,
	"./jp.svg": 20050,
	"./ke.svg": 45804,
	"./kg.svg": 85747,
	"./kh.svg": 66532,
	"./ki.svg": 56146,
	"./km.svg": 85788,
	"./kn.svg": 42170,
	"./kp.svg": 95358,
	"./kr.svg": 28387,
	"./kw.svg": 48548,
	"./ky.svg": 94113,
	"./kz.svg": 23131,
	"./la.svg": 84010,
	"./lb.svg": 98229,
	"./li.svg": 82906,
	"./lk.svg": 60518,
	"./lr.svg": 35076,
	"./ls.svg": 98907,
	"./lt.svg": 92230,
	"./lu.svg": 80506,
	"./lv.svg": 81495,
	"./ly.svg": 68366,
	"./ma.svg": 1316,
	"./mc.svg": 92092,
	"./md.svg": 2030,
	"./me.svg": 84219,
	"./mg.svg": 82759,
	"./mh.svg": 80332,
	"./mk.svg": 89612,
	"./ml.svg": 64188,
	"./mm.svg": 50288,
	"./mn.svg": 70670,
	"./mo.svg": 37240,
	"./mp.svg": 97142,
	"./mq.svg": 7353,
	"./mr.svg": 25398,
	"./ms.svg": 71050,
	"./mt.svg": 94826,
	"./mu.svg": 34255,
	"./mv.svg": 65990,
	"./mw.svg": 78896,
	"./mx.svg": 96445,
	"./my.svg": 14186,
	"./mz.svg": 56019,
	"./na.svg": 21941,
	"./nato.svg": 9243,
	"./ne.svg": 8564,
	"./nf.svg": 67446,
	"./ng.svg": 69227,
	"./ni.svg": 71688,
	"./nl.svg": 5055,
	"./no.svg": 93140,
	"./np.svg": 87108,
	"./nr.svg": 35901,
	"./nu.svg": 43901,
	"./nz.svg": 38678,
	"./om.svg": 55070,
	"./pa.svg": 12395,
	"./pe.svg": 11433,
	"./pf.svg": 553,
	"./pg.svg": 44190,
	"./ph.svg": 50079,
	"./pk.svg": 43506,
	"./pl.svg": 46357,
	"./pn.svg": 51555,
	"./pr.svg": 3094,
	"./ps.svg": 46731,
	"./pt.svg": 25217,
	"./pw.svg": 49921,
	"./py.svg": 84942,
	"./qa.svg": 94689,
	"./ro.svg": 29570,
	"./rs.svg": 93859,
	"./ru.svg": 79382,
	"./rw.svg": 72700,
	"./sa.svg": 11228,
	"./sb.svg": 42881,
	"./sc.svg": 17698,
	"./sd.svg": 50250,
	"./se.svg": 29836,
	"./sg.svg": 50008,
	"./si.svg": 96866,
	"./sk.svg": 64105,
	"./sl.svg": 61751,
	"./sm.svg": 73722,
	"./sn.svg": 3102,
	"./so.svg": 44214,
	"./sr.svg": 6915,
	"./ss.svg": 31262,
	"./st.svg": 37311,
	"./sv.svg": 54224,
	"./sx.svg": 75440,
	"./sy.svg": 18935,
	"./sz.svg": 32684,
	"./tc.svg": 90554,
	"./td.svg": 18699,
	"./tg.svg": 98741,
	"./th.svg": 93257,
	"./tibet.svg": 22860,
	"./tj.svg": 88960,
	"./tk.svg": 46207,
	"./tm.svg": 15195,
	"./tn.svg": 64261,
	"./to.svg": 31465,
	"./tr.svg": 15476,
	"./tt.svg": 27749,
	"./tv.svg": 20657,
	"./tw.svg": 74774,
	"./tz.svg": 87120,
	"./ua.svg": 50514,
	"./ug.svg": 84996,
	"./us.svg": 57699,
	"./uy.svg": 75277,
	"./uz.svg": 51331,
	"./ve.svg": 29544,
	"./vi.svg": 89684,
	"./vn.svg": 15359,
	"./vu.svg": 4584,
	"./ws.svg": 86148,
	"./ye.svg": 69049,
	"./za.svg": 88693,
	"./zm.svg": 75026,
	"./zw.svg": 31897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52107;